import { render, staticRenderFns } from "./TasksGanttDefaultItem.vue?vue&type=template&id=e80876f2&scoped=true"
import script from "./TasksGanttDefaultItem.vue?vue&type=script&lang=js"
export * from "./TasksGanttDefaultItem.vue?vue&type=script&lang=js"
import style0 from "./TasksGanttDefaultItem.vue?vue&type=style&index=0&id=e80876f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80876f2",
  null
  
)

export default component.exports